import { render } from "./SVFooter.vue?vue&type=template&id=ab996060&scoped=true"
import script from "./SVFooter.vue?vue&type=script&lang=js"
export * from "./SVFooter.vue?vue&type=script&lang=js"

import "./SVFooter.vue?vue&type=style&index=0&id=ab996060&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab996060"]])

export default __exports__